import React from 'react';
import { motion } from 'framer-motion';
import { useWallet } from '../context/WalletContext';

const formatChain = (chainId: string | null) => {
  if (!chainId) return 'Unknown';
  return chainId;
};

export default function Web3() {
  const {
    isConnected,
    address,
    chainId,
    isMetaMaskInstalled,
    connectWallet,
    disconnectWallet,
    error,
    balance
  } = useWallet();

  return (
    <div className="bg-gray-900 min-h-screen w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Web3
          </h1>
        </motion.div>

        <div className="mt-8 bg-gray-800/80 border border-gray-700 rounded-2xl p-6 max-w-2xl">
          <h2 className="text-xl font-semibold text-white">MetaMask Wallet</h2>

          {!isMetaMaskInstalled && (
            <div className="mt-4 bg-amber-900/30 border border-amber-700 text-amber-200 text-sm rounded-lg p-3">
              MetaMask not detected. Install it to connect.
              <a
                className="ml-2 underline text-amber-100"
                href="https://metamask.io/download/"
                target="_blank"
                rel="noreferrer"
              >
                Get MetaMask
              </a>
            </div>
          )}

          {error && (
            <div className="mt-4 bg-red-900/30 border border-red-700 text-red-200 text-sm rounded-lg p-3">
              {error}
            </div>
          )}

          <div className="mt-6 space-y-2 text-gray-300">
            <div>
              <span className="text-gray-400">Status:</span>{' '}
              {isConnected ? 'Connected' : 'Disconnected'}
            </div>
            <div>
              <span className="text-gray-400">Address:</span>{' '}
              {address ?? 'Not connected'}
            </div>
            <div>
              <span className="text-gray-400">Chain ID:</span>{' '}
              {formatChain(chainId)}
            </div>
            <div>
              <span className="text-gray-400">Balance:</span>{' '}
              {balance ? `${balance} ETH` : '—'}
            </div>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <button
              onClick={connectWallet}
              disabled={!isMetaMaskInstalled}
              className={`px-4 py-2 rounded-lg text-white bg-indigo-600 hover:bg-indigo-500 transition-colors ${
                !isMetaMaskInstalled ? 'opacity-60 cursor-not-allowed' : ''
              }`}
            >
              Connect MetaMask
            </button>
            <button
              onClick={disconnectWallet}
              disabled={!isConnected}
              className={`px-4 py-2 rounded-lg text-white bg-gray-700 hover:bg-gray-600 transition-colors ${
                !isConnected ? 'opacity-60 cursor-not-allowed' : ''
              }`}
            >
              Disconnect
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
